import { WishlistEntry } from '@wishlist/const';
import { WishlistActions } from '../actions';

const initialEntries: WishlistEntry[] = [];

export function wishlistEntryListValueReducer(
  entries = initialEntries,
  action:
    | WishlistActions.LoadWishlistEntryListSuccess
    | WishlistActions.LoadWishlistEntryListFail
    | WishlistActions.ResetWishlistEntryList
    | WishlistActions.AddWishlistEntrySuccess
    | WishlistActions.RemoveWishlistEntrySuccess,
): WishlistEntry[] {
  switch (action.type) {
    case WishlistActions.LOAD_WISHLIST_ENTRY_LIST_SUCCESS:
      entries = action.payload;
      break;

    case WishlistActions.LOAD_WISHLIST_ENTRY_LIST_FAIL:
    case WishlistActions.RESET_WISHLIST_ENTRY_LIST:
      entries = initialEntries;
      break;

    case WishlistActions.ADD_WISHLIST_ENTRY_SUCCESS: {
      if (entries) {
        entries = entries.filter((entry) => entry.productCode !== action.payload.productCode);
      }
      entries.unshift(action.payload);
      break;
    }

    case WishlistActions.REMOVE_WISHLIST_ENTRY_SUCCESS: {
      if (entries) {
        entries = entries.filter((entry) => entry.productCode !== action.payload.productCode);
      }
      break;
    }
  }

  return entries;
}
